export default __webpack_public_path__ + "static/media/check-en-empty.dc58a0be.svg";